// src/components/ProjectsGrid.jsx

import React, { Suspense } from "react";
import Slider from "react-slick";
import ProjectCard from "./ProjectCard";

const ProjectsGrid = ({ repos, sliderSettings }) => {
  if (repos.length === 0) {
    return <p className="text-center text-xl">No projects found.</p>;
  }

  return (
    <>
      {/* Carousel for Mobile */}
      <div className="block md:hidden">
        <Slider {...sliderSettings}>
          {repos.map((repo) => (
            <Suspense fallback={<div>Loading project...</div>} key={repo.id}>
              <ProjectCard repo={repo} />
            </Suspense>
          ))}
        </Slider>
      </div>

      {/* Grid for Desktop */}
      <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {repos.map((repo) => (
          <Suspense fallback={<div>Loading project...</div>} key={repo.id}>
            <ProjectCard repo={repo} />
          </Suspense>
        ))}
      </div>
    </>
  );
};

export default ProjectsGrid;
